import { memo } from "react";

function Image(props) {
  return (
    <div
      ref={props.editorRef}
      style={{
        visibility: props.block.hidden ? "hidden" : "unset",
        position: "relative",
        backgroundImage: `url(${props.block.props.image})`,
        flexGrow: props.block.props.flexGrow,
        backgroundSize: props.block.props.backgroundSize,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: props.block.props.backgroundColor,
        boxShadow: props.block.props.boxShadow,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
      }}
    ></div>
  );
}

export default memo(Image);
